import Vue from 'vue';
import { compileToFunctions } from 'vue-template-compiler';

Vue.directive('addHtml', {
	bind(el, binding) {
		el.innerHTML = binding.value;
	  },
	  // update é chamado quando o valor da diretiva é atualizado.
	  update(el, binding) {
		el.innerHTML = binding.value;
	  },
});